import { startServiceWorker } from './startServiceWorker';
import { unregisterServiceWorker } from './unregisterServiceWorker';
import { debug } from '../../utils/DebugUtil';
import { LEGACY_NOTIFICATIONS_SERVICE_WORKER_URL } from './constants';
import { canShowBrowserNotifications } from './canShowBrowserNotifications';
import { startPresencePing } from './presence/startPresencePing';
import { listenToPushSubscriptionChanged } from './subscription';
import { startPushNotificationSubscription } from './startPushNotificationSubscription';

/**
 * Remove the old service worker from the Navigation repository
 */
const removeUnwantedWorker = async () => {
  try {
    await unregisterServiceWorker(LEGACY_NOTIFICATIONS_SERVICE_WORKER_URL);
  } catch (error) {
    debug('Could not unregister the unwanted legacy service worker', error);
    throw error;
  }
};

/**
 * This is the entry point for browser notifications support.
 * It should be called even if the browser notification gate is disabled so that we can
 * remove our existing worker if the gate was previously on
 */
export const startBrowserNotifications = async userId => {
  if ('serviceWorker' in navigator) {
    try {
      startPresencePing(userId);
      await removeUnwantedWorker();
      if (!canShowBrowserNotifications()) {
        debug('browser notifications will not be enabled');
        return;
      }
      const registration = await startServiceWorker();
      if (!registration) {
        debug('could not start the service worker, not continuing to setup browser notifications');
        return;
      }
      const subscribed = await startPushNotificationSubscription(registration);
      if (subscribed) {
        listenToPushSubscriptionChanged(registration);
      }
      debug('browser notifications fully setup');
    } catch (error) {
      debug('failed to start browser notifications', error);
      throw error;
    }
  }
};